import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import Markdown from 'preact-markdown';

@observer
class AiAnimalSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            summary: '',
            error: null,
            fromCache: false,
        };
    }

    loadSummary = async (skipCache = false) => {
        const { animalId } = this.props;
        if (!animalId) {
            this.setState({ loading: false, error: 'No animal ID provided.' });
            return;
        }

        this.setState({ loading: true, error: null, summary: '' });

        try {
            const response = await util.fetchApi('/api/ai/animal-summary', { method: 'POST' }, { animalId, skipCache });
            const data = response?.data;
            const outputText = data?.output_text || '';
            const fromCache = response?.message?.includes('cache') || false;
            this.setState({ loading: false, summary: outputText, fromCache });
        } catch (err) {
            this.setState({ loading: false, error: 'Kunne ikke hente AI-sammendrag.' });
        }
    }

    onClickRefresh = () => {
        this.loadSummary(true);
    }

    componentDidMount() {
        this.loadSummary();
    }

    render() {
        const { loading, summary, error, fromCache } = this.state;
        const { animalId, drawerLevel = 1 } = this.props;
        const { appState, animalStore } = this.props.stores;

        const { animal = {} } = animalStore;
        const animalName = animal?.id === animalId ? animal.name : '';

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='font-weight-lighter px-3 box-header d-flex flex-row align-items-center justify-content-between'>
                        <div>
                            <i class='fa-solid fa-wand-magic-sparkles me-2' />
                            AI Sammendrag
                            {animalName && <span class='ms-2'>- {animalName}</span>}
                        </div>
                        <button
                            class='btn btn-sm btn-outline-secondary rounded-pill py-0'
                            onClick={this.onClickRefresh}
                            disabled={loading}
                        >
                            <i class={`fa-solid fa-arrows-rotate ${loading ? 'fa-spin' : ''}`} /> Oppdater
                        </button>
                    </div>

                    {fromCache && (
                        <div class='px-3 mb-2'>
                            <small class='text-body-secondary'>
                                <i class='fa-solid fa-database me-1' />
                                Fra hurtigbuffer (siste 30 dager)
                            </small>
                        </div>
                    )}

                    <div class='px-3 mt-3 mb-2'>
                        <div class='alert alert-warning mb-0'>
                            <i class='fa-solid fa-triangle-exclamation me-2' />
                            <small>Dette er et AI-generert sammendrag og kan inneholde feil. Verifiser alltid informasjonen mot originaljournalene.</small>
                        </div>
                    </div>

                    <div class='px-3 py-2'>
                        {loading && (
                            <div class='d-flex flex-column align-items-center justify-content-center py-5'>
                                <i class='fa-solid fa-spinner fa-spin fa-2x mb-3' />
                                <div class='text-body-secondary'>Genererer AI-sammendrag...</div>
                            </div>
                        )}

                        {error && (
                            <div class='alert alert-danger'>
                                <i class='fa-solid fa-exclamation-triangle me-2' />
                                {error}
                            </div>
                        )}

                        {!loading && !error && summary && (
                            <div class='card'>
                                <div class='card-body'>
                                    <Markdown markdown={summary} />
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default AiAnimalSummary;
